function isString(value) {
    return typeof value === 'string' || value instanceof String;
}

export { isString };
